import { ElementRef, NgModule, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CpWidgetComponent } from './cp-widget.component';
import { PoModule } from '@po-ui/ng-components';


@NgModule({
  declarations: [CpWidgetComponent],
  exports: [CpWidgetComponent],
  imports: [CommonModule,
            PoModule]
})
export class CpWidgetModule {
  @ViewChild('infopopup', { read: ElementRef, static: true }) infopopupref: ElementRef;
}

